<template>
  <div id="app">
    <Headers></Headers>
    <Index></Index>
  </div>
</template>

<script>
import Headers from './components/Headers.vue'
import Index from './views/index'

export default {
  name: 'app',
  components: {
    Headers,
    Index
  }
}
</script>

<style>
html,
body {
  min-width: 1366px !important;
  min-height: 668px !important;
}
* {
  margin: 0;
  padding: 0;
  font-family: '微软雅黑', 'Arial';
}

#app {
  position: relative;
}

#app .sw-filing {
  width: 162px;
  position: absolute;
  bottom: -30px;
  left: 50%;
  margin-left: -81px;
  font-size: 12px;
  color: #9ba5b4;
}
</style>
